// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__yB4Mz","icon":"Breadcrumbs_icon__dn8z7"};